import { cn } from '@/lib/utils';

interface OnlineIndicatorProps {
  /** True when the user is considered online. */
  isOnline: boolean;
  size?: 'sm' | 'md';
  className?: string;
}

/**
 * Small dot that shows whether a user is online.
 * Green = online (active within the last 5 minutes), absent = offline.
 */
export function OnlineIndicator({ isOnline, size = 'sm', className }: OnlineIndicatorProps) {
  if (!isOnline) return null;

  const dotSize = size === 'sm' ? 'h-2 w-2' : 'h-2.5 w-2.5';

  return (
    <span
      className={cn(
        'absolute -bottom-0.5 -right-0.5 rounded-full bg-green-400 border-2 border-white dark:border-neutral-900',
        dotSize,
        className,
      )}
      aria-label="Online"
    />
  );
}
